import styled, { css } from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';

const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 24px;

  ${media.iwNotDesktop} {
    padding: 16px;
    gap: 0px;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  gap: 16px;
  overflow: hidden;

  ${media.iwDesktop} {
    border-left: 1px solid ${COLORS.grey};
    padding: 24px;
    overflow-y: auto;
    min-width: calc(
      var(--iw-sidebar-desktop-width-expanded) - var(--iw-sidebar-desktop-width-folded)
    );
  }
`;

const AnimatedWrapper = styled.div<{ $isOpen: boolean }>`
  display: flex;

  overflow: hidden;

  ${media.iwNotDesktop} {
    max-height: ${({ $isOpen }) =>
      $isOpen
        ? css`var(--iw-sidebar-item-mobile-height-expanded)`
        : css`var(--iw-sidebar-item-mobile-height-folded)`};

    transition: max-height var(--ani-speed) ease-in-out;
  }
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
`;

export const InterwillInfoPanelStyledComponents = {
  NavContainer,
  ContentContainer,
  AnimatedWrapper,
  Title,
};
